import { render, staticRenderFns } from "./MetricsPage.vue?vue&type=template&id=a0112d06&"
import script from "./MetricsPage.vue?vue&type=script&lang=ts&"
export * from "./MetricsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MetricsPage.vue?vue&type=style&index=0&id=a0112d06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports